import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';

const LoginPage = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#2A2520] flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative max-w-md w-full"
      >
        <div className="bg-[#F5F1E8]/5 backdrop-blur-sm border border-[#F5F1E8]/10 p-10 shadow-2xl">
          <div className="text-center mb-10">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.3, duration: 0.5, type: 'spring' }}
              className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#D4AF37]/20 flex items-center justify-center"
            >
              <Lock className="w-7 h-7 text-[#D4AF37]" />
            </motion.div>
            <h1 className="text-3xl font-serif text-[#F5F1E8] mb-2">
              Area Riservata
            </h1>
            <p className="text-[#D4AF37] text-xs tracking-widest uppercase">
              Ca' del Sole Italia
            </p>
          </div>

          <p className="text-[#F5F1E8]/70 text-sm text-center mb-8 leading-relaxed">
            Accedi con il tuo account Google autorizzato per gestire le richieste di contatto ricevute dal sito.
          </p>

          <motion.button
            onClick={handleGoogleLogin}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="w-full bg-white text-[#2A2520] py-4 px-6 flex items-center justify-center gap-3 font-semibold hover:bg-[#D4AF37] transition-all duration-300 shadow-lg"
            data-testid="google-login-btn"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Accedi con Google
          </motion.button>

          <p className="text-[#F5F1E8]/40 text-xs text-center mt-6">
            Solo gli account autorizzati potranno accedere all'area admin.
          </p>
        </div>

        <div className="text-center mt-6">
          <a
            href="/"
            className="text-[#F5F1E8]/60 hover:text-[#D4AF37] transition-colors duration-300 text-sm"
            data-testid="back-to-site-link"
          >
            ← Torna al sito
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginPage;
